/**
 * C# string formatting.
 * @param format
 * @param args
 */
export function formatString(format: string, args: Array<any>) {
    return format.replace(/{(\d+)}/g, (match, number) => {
        return typeof args[number] != 'undefined'
            ? args[number]
            : match
            ;
    });
}

export function isNullOrEmpty(str: string) {
    return !(str != null && str.length > 0);
}

export function formatId(id: string) {
    // Match and remove any non-alpha characters
    return id ? id.replace(/[^\w]/gi, '') : "X";
}